<div *ngIf="isPageReady" class="flex flex-col h-full w-full">
  <h4 class="mb-2">Consolidate Product Tags</h4>
  <p class="mb-4 text-sm">
    Select the tag that will <span class="font-semibold">remain</span>. All other selected tags will be folded into it and then deleted. Every issuance, menu category, product mapping, and historical user log that referenced the folded tags will be re-attributed to the canonical tag.
  </p>

  <div class="mb-4">
    <div class="qb-group-label mb-2">Selected tags ({{ selectedTags.length }}) &mdash; choose which one to keep</div>
    <div class="flex flex-col gap-2 pl-2">
      <div *ngFor="let tag of selectedTags" class="flex items-center">
        <p-radiobutton [inputId]="'canon-' + tag.id" name="canonicalTag" [value]="tag.id"
          [(ngModel)]="canonicalTagId" (onClick)="onCanonicalChange()"></p-radiobutton>
        <label [for]="'canon-' + tag.id" class="ml-2">{{ tag.name }}</label>
      </div>
    </div>
  </div>

  <div class="flex items-center gap-3 mb-4">
    <p-button [disabled]="!canCheckLegality()" (onClick)="onCheckLegality()" size="small" label="Check Legality"
      icon="pi pi-search"></p-button>
    <span *ngIf="isCheckingLegality" class="text-sm">Checking&hellip;</span>
  </div>

  <!-- Legality result panel -->
  <div *ngIf="legality" class="mb-4">

    <!-- LEGAL -->
    <div *ngIf="legality.IsLegal" class="qb-insight-box">
      <div class="font-semibold mb-2">Ready to consolidate</div>
      <div class="text-sm">
        Folding
        <span class="font-semibold">{{ legality.SynonymTagNames.join(', ') }}</span>
        into
        <span class="font-semibold">'{{ legality.CanonicalTagName }}'</span>:
      </div>
      <ul class="text-sm list-disc pl-6 mt-2">
        <li>{{ legality.IssuanceRefs }} issuance reference(s) will be re-pointed</li>
        <li>{{ legality.AffectedPugCount }} program user group(s) affected</li>
        <li>{{ legality.ProductTypeMapRefs }} product-type mapping(s) re-pointed (duplicates auto-dedupe)</li>
        <li>{{ legality.CategoryMapRefs }} menu-category mapping(s) re-pointed (duplicates auto-dedupe)</li>
        <li>{{ legality.SynonymTagNames.length }} synonym tag(s) will be permanently deleted</li>
      </ul>
    </div>

    <!-- RULE A violation: straddling PUGs -->
    <div *ngIf="!legality.IsLegal && legality.IsRuleAViolation" class="qb-insight-box">
      <div class="font-semibold mb-2 red_pointer">Cannot consolidate &mdash; PUGs straddle multiple tags</div>
      <div class="text-sm mb-2">{{ legality.RefusalReason }}</div>
      <div class="text-sm font-semibold mt-2">Straddling PUGs:</div>
      <ul class="text-sm list-disc pl-6 mt-1">
        <li *ngFor="let s of legality.StraddlingPugs">
          <span class="font-semibold">{{ s.PugName }}</span> ({{ s.ScopeLabel }}) &mdash;
          references tags: {{ s.StraddledTagNames.join(', ') }}
          <span class="italic">via issuances: {{ s.IssuanceNames.join(', ') }}</span>
        </li>
      </ul>
    </div>

    <!-- Any other refusal (e.g., tags not found) -->
    <div *ngIf="!legality.IsLegal && !legality.IsRuleAViolation" class="qb-insight-box">
      <div class="font-semibold mb-2 red_pointer">Cannot consolidate</div>
      <div class="text-sm">{{ legality.RefusalReason }}</div>
    </div>
  </div>

  <div class="flex pt-2 items-center gap-2">
    <p-button [disabled]="!canConsolidate()" (onClick)="onConsolidate()" label="Consolidate" icon="pi pi-check"></p-button>
    <p-button (onClick)="onCancel()" label="Cancel" icon="pi pi-times" severity="secondary"></p-button>
    <span *ngIf="isExecuting" class="text-sm ml-2">Consolidating&hellip;</span>
  </div>
</div>
